import { createFileRoute } from '@tanstack/react-router';
import { PerfisPage } from '@/components/perfis';

export const Route = createFileRoute('/_app/configuracoes/perfis')({
  component: PerfisPage,
});
